/* Angular Packages */
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

/* IXFI Library Modules */
import { FooterModule } from 'footer';
import { HeaderModule } from 'header';

/* Angular Component */
import { ShellComponent } from './components/shell/shell.component';
import { LoaderComponent } from './components/loader/loader.component';
import { OfflineComponent } from './components/offline/offline.component';

/* Angular Services */
import { AuthInterceptor } from './services/interceptor/auth.interceptor';
import { HttpErrorInterceptor } from './services/interceptor/http-error.interceptor';

/* 3rd Party Packages */
import { ToastrModule } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

/* Lottie Module */
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
// Required for AOT Compilation
export function playerFactory() {
    return player;
}

/* Translate Module */
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';
import { ConfirmPopupComponent } from '../standalone/components/confirm-popup/confirm-popup.component';
import { TransferState } from '@angular/platform-browser';
import { translateBrowserLoaderFactory } from '../translate-browser.loader';
import { IntercomModule } from 'ng-intercom-x';

// Required for AOT Compilation
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, environment.LANGUAGE_URL, '.json');
}

@NgModule({
    declarations: [LoaderComponent, ShellComponent, OfflineComponent],
    imports: [
        RouterModule,
        CommonModule,
        FooterModule.forRoot(environment),
        HeaderModule.forRoot(environment),
        HttpClientModule,
        NgbDropdownModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        IntercomModule.forRoot({
            appId: environment.INTERCOM_APP_ID, // from your Intercom config
            updateOnRouterChange: true // will automatically run `update` on router event changes. Default: `false`
        }),
        ToastrModule.forRoot({
            preventDuplicates: true
        }),
         LottieModule.forRoot({ player: playerFactory }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: translateBrowserLoaderFactory,
                deps: [HttpClient, TransferState]
            }
        }),
        // Standalone
         ConfirmPopupComponent
    ],
    providers: [
        CookieService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }
    ],
    exports: [LoaderComponent, OfflineComponent]
})
export class CoreModule {}
